import React, { useState } from "react";
import "../Components/FlipCard.scss";
import cn from "classnames";

function FlipCard({ card }) {
  const [showBack, setShowBack] = useState(false);

  const handleClick = () => {
    if (card.variant === "click") {
      setShowBack((prev) => !prev);
    }
  };

  return (
    <div className="flip-card-container">
      <div
        tabIndex={0}
        className={cn("flip-card-outer", {
          "focus-trigger": card.variant === "focus",
        })}
        onClick={handleClick}
      >
        <div
          className={cn("flip-card-inner", {
            showBack,
            "hover-trigger": card.variant === "hover",
          })}
        >
          {/* FRONT */}{" "}
          <div className="card front">
            {" "}
            <div className="card-body d-flex justify-content-center align-items-center">
              {" "}
              <div className="card-text fs-1 fw-bold">{card.front} </div>{" "}
            </div>{" "}
          </div>
          
          {/* BACK */}
          <div className="card back">
            <div className="card-body d-flex justify-content-center align-items-center">
              <div className="card-text fs-1 fw-bold">{card.back}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FlipCard;
